import { Injectable } from "@angular/core";
import { UserInfoService } from "../auth/user-info.service";
import { ScriptLoaderService } from "../utility/script-loader.service";

@Injectable()
export class EcapCoreMixPanelService {
    
    constructor(private userInfoService:UserInfoService,
        private scriptLoaderService :ScriptLoaderService){
    }

   public registerMixPanel():void{
        const tenantInfo = this.userInfoService.getTenantInfo();
        if (tenantInfo && tenantInfo.AnalyticsProvider) {
            this.scriptLoaderService.load([tenantInfo.AnalyticsProvider], tenantInfo.AnalyticsTrackingId).then(data => {
                console.log('mixpanel script loaded ', data);
            }).catch(error => console.log(error));
        }
        else {
            this.userInfoService.getIdentity().subscribe((response) => {
                if (response && response.AnalyticsProvider) {
                    this.scriptLoaderService.load([response.AnalyticsProvider], response.AnalyticsTrackingId).then(data => {
                        console.log('mixpanel script loaded ', data);
                    }).catch(error => console.log(error));
                }
            });
        }
    }
}